import { Delete, PhoneCall, PhoneOff } from 'lucide-react';
import { IoKeypad } from "react-icons/io5";

import React, { useContext, } from 'react';
import { Discador, DiscadorContext, useKeyboardInput } from '../../../../Discador';
import { aplicarMascara } from '../../../../../utils/mascaraTelefone';
import { CustomFlowbiteTheme, Tooltip } from 'flowbite-react';
import { useModal } from '../../../../../hooks/ModalContext';

export const Ligacao = () => {
  const {
    iniciarSessao,
    finalizarSessao,
    onCall,
    isLogged,
    onRinging,
    finalizarChamada,
    iniciarChamada,
    dadosLogin,
    isConnected,
    operadorManualState,
    operadorManual,
    operadorAtivo,
    agentIsACW
  } = useContext(DiscadorContext);
  const { setModal } = useModal()

  const { virtualInteraction, value: phoneNumber } = useKeyboardInput('');

  const themeTooltip: CustomFlowbiteTheme['tooltip'] = {
    base: 'absolute inline-block z-20 rounded-lg py-2 px-3 text-sm font-medium shadow-sm'
  }
  // ${!isConnected && 'hidden'}

  return (
    <div className="h-full w-full overflow-y-auto">
      <div className={`flex w-full max-w-xl flex-col items-center text-xs lg:text-sm `}>
        <div className='flex gap-2 items-center m-2 text-sm'>
          <div className={`${!isConnected ? 'bg-amber-400' : 'bg-green-500'} h-3 w-3 rounded-full`}></div>
          <p>{!isConnected ? 'Atualizando conexão' : 'Conectado'}</p>
        </div>
        {
          operadorManualState ? (
            <Discador.Root>
              <Discador.Header
                onRinging={onRinging}
                onCall={onCall}
                phoneNumber={aplicarMascara(phoneNumber)}
                isLogged={isLogged}
                onChangeHandler={() => {
                  if (isLogged) return finalizarSessao();
                  iniciarSessao();
                }}
                isHibrido
              />
              <Discador.NumbersRoot>
                <Discador.Number
                  onNumberPressed={virtualInteraction}
                  number="1"
                  disabled={!isLogged || onCall || onRinging}
                />
                <Discador.Number
                  onNumberPressed={virtualInteraction}
                  number="2"
                  disabled={!isLogged || onCall || onRinging}
                />
                <Discador.Number
                  onNumberPressed={virtualInteraction}
                  number="3"
                  disabled={!isLogged || onCall || onRinging}
                />
                <Discador.Number
                  onNumberPressed={virtualInteraction}
                  number="4"
                  disabled={!isLogged || onCall || onRinging}
                />
                <Discador.Number
                  onNumberPressed={virtualInteraction}
                  number="5"
                  disabled={!isLogged || onCall || onRinging}
                />
                <Discador.Number
                  onNumberPressed={virtualInteraction}
                  number="6"
                  disabled={!isLogged || onCall || onRinging}
                />
                <Discador.Number
                  onNumberPressed={virtualInteraction}
                  number="7"
                  disabled={!isLogged || onCall || onRinging}
                />
                <Discador.Number
                  onNumberPressed={virtualInteraction}
                  number="8"
                  disabled={!isLogged || onCall || onRinging}
                />
                <Discador.Number
                  onNumberPressed={virtualInteraction}
                  number="9"
                  disabled={!isLogged || onCall || onRinging}
                />
                <Discador.Number onNumberPressed={() => { }} number="*" hidden />
                <Discador.Number
                  onNumberPressed={virtualInteraction}
                  number="0"
                  disabled={!isLogged || onCall || onRinging}
                />
                <Discador.Number onNumberPressed={() => { }} number="#" hidden />
              </Discador.NumbersRoot>
              <Discador.ActionsRoot>
                <Discador.Action
                  icon={PhoneCall}
                  className="rounded-full bg-green-600 p-3 disabled:bg-green-300 disabled:hover:bg-green-300"
                  disabled={onCall || onRinging || phoneNumber.length < 10 || !isLogged}
                  iconColor="#fff"
                  onClick={() => {
                    iniciarChamada(
                      dadosLogin!.idUsuario,
                      phoneNumber.substring(0, 2),
                      phoneNumber.substring(2),
                      dadosLogin!.idGrupo
                    );
                  }}
                />

                <Discador.Action
                  icon={PhoneOff}
                  className="rounded-full bg-red-700 p-3 disabled:bg-red-200 disabled:hover:bg-red-200"
                  iconColor="#fff"
                  disabled={!onCall || !isLogged}
                  onClick={() => {
                    finalizarChamada(dadosLogin!.idUsuario);
                  }}
                />

                <Discador.Action
                  icon={Delete}
                  className="rounded-full bg-slate-300 p-3"
                  disabled={onCall || onRinging || !isLogged}
                  onClick={() => virtualInteraction('Backspace')}
                />
              </Discador.ActionsRoot>
              <Discador.ActionText
                text={'Sair do Manual'}
                className="rounded-md bg-red-400 p-3 mt-8  text-white font-semibold"
                disabled={onCall || onRinging || !isLogged}
                onClick={() => {
                  operadorAtivo()
                }}
              />
            </Discador.Root>
          ) : (
            <Discador.Root>
              <div className={`${!agentIsACW && onCall && 'hidden'} m-4`}>
                <p className='font-semibold text-primary text-sm w-full text-center'>{!agentIsACW && !onCall && isLogged ? 'Agente está ocioso' : 'Agente deslogado'} </p>
              </div>
              <Discador.Header
                onRinging={onRinging}
                onCall={onCall}
                phoneNumber={aplicarMascara(phoneNumber)}
                isLogged={isLogged}
                onChangeHandler={() => {
                  if (isLogged) return finalizarSessao();
                  iniciarSessao();
                }}
                isHibrido
              />
              <Discador.ActionsRoot>
                <Tooltip content={'Discagem Manual'} placement="bottom" theme={themeTooltip}>
                  <Discador.Action
                    icon={IoKeypad}
                    className="rounded-full bg-slate-400 p-3 disabled:bg-slate-300 disabled:hover:bg-slate-300"
                    iconColor="#fff"
                    disabled={onCall || onRinging || !isLogged}
                    onClick={() => {
                      operadorManual()
                    }}
                  />
                </Tooltip>

                <Discador.Action
                  icon={PhoneOff}
                  className="rounded-full bg-red-700 p-3 disabled:bg-red-200 disabled:hover:bg-red-200"
                  iconColor="#fff"
                  disabled={!onCall || !isLogged}
                  onClick={() => {
                    finalizarChamada(dadosLogin!.idUsuario);
                  }}
                />

              </Discador.ActionsRoot>

              <div className={`${!agentIsACW && 'hidden'} m-4`}>
                <button className='p-2 text-white font-semibold bg-primary text-center rounded-md'
                  onClick={() => setModal('Qualificacao Chamada', 'Qualificacao Chamada', false, false)}
                >Abrir Qualificações</button>
              </div>
            </Discador.Root>
          )
        }
      </div>


    </div>
  );
};
